<template>
  <form-modal
    modal-title="Agregar Evaluación"
    @closeModal="$emit('closeModal')"
    hide-secondary-button
    @primaryButtonClick="onSubmit"
  >
    <div class="branch-evaluation-form">
      <el-form
        ref="form"
        :rules="rules"
        :model="model"
        label-width="80px"
        label-position="right"
      >
        <el-form-item
          label="Periodo"
          prop="periodId"
        >
          <el-select
            v-model="model.periodId"
            filterable
            remote
            placeholder="Escriba el periodo"
            :remote-method="onLoadPeriod"
            :loading="isLoadingPeriods"
          >
            <el-option
              v-for="item in periods"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="Layout"
          prop="layoutId"
        >
          <el-select
            v-model="model.layoutId"
            filterable
            remote
            placeholder="Escriba el layout"
            :remote-method="onLoadLayouts"
            :loading="isLoadingLayouts"
            @change="onChangeLayout"
          >
            <el-option
              v-for="item in layouts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Rango">
          <el-date-picker
            v-model="dateRange"
            :picker-options="pickerOptions"
            type="daterange"
            range-separator="-"
            start-placeholder="Inicio"
            end-placeholder="Fin"
            @change="updateDates"
          />
        </el-form-item>
      </el-form>
    </div>
  </form-modal>
</template>

<script>
import FormModal from '@/components/_shared/form-modal'
import Evaluation from '@/models/evaluation.model'
import { mapGetters, mapActions } from 'vuex'
/**
 * 'BranchEvaluationForm' Component
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default {
  name: 'BranchEvaluationForm',
  components: { FormModal },
  props: {
    branchId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      model: Evaluation.model(),
      dateRange: [],
      isLoadingPeriods: false,
      isLoadingLayouts: false,
      rules: Evaluation.rules(),
      pickerOptions: {
        disabledDate: time => {
          let currentDate = new Date(time)
          let startDate = new Date(this.currentPeriod.startDate)
          let endDate = new Date(this.currentPeriod.endDate)
          return !(startDate <= currentDate && endDate >= currentDate)
        }
      }
    }
  },
  computed: {
    currentPeriod () {
      return this.periods.find(element => {
        return element.id === this.model.periodId
      })
    },
    ...mapGetters('periods', {
      periods: 'items'
    }),
    ...mapGetters('layouts', {
      layouts: 'items'
    })
  },
  mounted () {
    this.model.branchId = this.branchId
  },
  beforeCreate () {
    this.$store.dispatch('periods/query')
    this.$store.dispatch('layouts/query')
  },
  methods: {
    ...mapActions('evaluations', ['save', 'query']),
    ...mapActions('periods', { queryPeriods: 'query' }),
    ...mapActions('layouts', { queryLayouts: 'query' }),
    isDateDisabled (date) {
      return false
    },
    onChangeLayout (e) {
      let currentLayout = this.layouts.find(x => {
        return x.id === e
      })
      this.model.division = currentLayout.division
    },
    onLoadPeriod (search) {
      this.isLoadingPeriods = true
      this.queryPeriods({
        'filters[where][name][contains]': search,
        select: 'id,name'
      }).finally(() => {
        this.isLoadingPeriods = false
      })
    },
    onLoadLayouts (search) {
      this.isLoadingLayouts = true
      this.queryLayouts({
        'filters[where][name][contains]': search,
        select: 'id,name'
      }).finally(() => {
        this.isLoadingLayouts = false
      })
    },
    onSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let loader = this.$loading()
          this.save(this.model)
            .then(response => {
              loader.close()
              this.$emit('onSave', this.model)
            })
            .catch(error => {
              loader.close()
              console.log(error)
              return Promise.reject(error)
            })
        } else {
          this.$notify({
            group: 'app',
            title: 'Verifica la forma.',
            text:
              'Por favor, revisa lo errores que se indican dentro de la forma.'
          })
          return false
        }
      })
    },
    updateDates () {
      this.model.startDate = this.dateRange[0]
      this.model.endDate = this.dateRange[1]
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style
        lang="scss"
        scoped
>
.branch-evaluation-form {
  padding: 30px 30px 0 30px;
}
</style>



// WEBPACK FOOTER //
// src/modules/branches/branch-evaluation-form.vue